import React from 'react';
import { motion } from 'framer-motion';
import { Link, Navigate, useLocation, useParams } from 'react-router-dom';
import { packagePlanMap } from '../data/packagePlans';
import '../csscomponent/PackageFlow.css';

function PaymentSuccess() {
  const { packageId } = useParams();
  const location = useLocation();
  const plan = packagePlanMap[packageId];
  const order = location.state?.order || null;

  if (!plan) {
    return <Navigate to="/services" replace />;
  }

  return (
    <section className="package-flow-page">
      <motion.div
        className="success-box"
        initial={{ opacity: 0, scale: 0.96 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.45 }}
      >
        <p>Payment Successful</p>
        <h1>{plan.name} Package Confirmed</h1>
        <span>
          Your booking has been recorded. Our team will contact you to start project onboarding.
        </span>
        {order?.orderCode ? (
          <p><strong>Order ID:</strong> {order.orderCode}</p>
        ) : null}
        <div className="flow-actions">
          <Link to="/services" className="flow-btn ghost">Back to Services</Link>
          <Link to="/dashboard" className="flow-btn ghost">View Order History</Link>
          <Link to="/brochure" className="flow-btn primary">View Brochure</Link>
        </div>
      </motion.div>
    </section>
  );
}

export default PaymentSuccess;
